<div class="card">
  <div class="card-header p-2" routerLink="/projekt">
    <button class="btn btn-primary btn-sm btn-floating float-end m-0" routerLink="/projekt">
      <i class="fal fa-search" aria-hidden="true"></i>
    </button>
    <h4 class="card-title mb-0 mt-1">
      <a class="text-reset text-decoration-none" routerLink="/projekt">
        <i class="fal fa-home" aria-hidden="true"></i>
        Projekt
      </a>
    </h4>
  </div>
  @if (!data) {
    <div class="card-body b2-card pe-2"></div>
  }
  @if (data) {
    <div class="card-body b2-card pe-2" [routerLink]="['/projekt', data.id]">
      <div class="card-text hand">
        <div>{{ data.dokument }}</div>
        <div>{{ data.bezeichnung }}</div>
        @if (getBauherr(data); as bauherr) {
          <div class="projekt-bauherr">
            <i class="fal fa-user" aria-hidden="true"></i>
            &nbsp;{{ bauherr }}
          </div>
        }
      </div>
    </div>
  }
</div>
